import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { InputRef } from 'antd';
import { Input, theme } from 'antd';
import type { SearchProps } from 'antd/es/input';
import { useTheme } from 'pos-client/theme/ThemeContext.ts';

import './PosSearchInput.css';

export type PosInputSearchProps = Omit<SearchProps, 'enterButton'>;

export const PosInputSearch = forwardRef<InputRef, PosInputSearchProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const { token } = theme.useToken();
    const { darkMode } = useTheme();

    return (
      <Input.Search
        ref={ref}
        {...props}
        width={props.width ?? '100%'}
        alt={props.alt ?? t('common.buttons.search')}
        enterButton={
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            color={darkMode ? token.blue : 'white'}
          />
        }
        className={darkMode ? 'input-search-dark' : props.className}
      />
    );
  }
);

PosInputSearch.displayName = 'PosInputSearch';
